import CardapioCliente from './CardapioCliente';
import CardapioCozinha from './CardapioCozinha';
import CardapioLicencaBloqueada from './CardapioLicencaBloqueada';
import CardapioPainel from './CardapioPainel';
import { buscarRestaurantePorSlug } from '../../utils/cardapio/persistencia';
import { verificarLicenca } from '../../utils/cardapio/licenca';

type ModoCardapio = 'cardapio' | 'cardapio-painel' | 'cardapio-cozinha';

/**
 * Entrada pública do produto Cardápio (links separados do bolão).
 * Parâmetros: ?modo=cardapio&r=slug&mesa=5
 */
export default function CardapioPublico({ modo }: { modo: ModoCardapio }) {
  const params = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : ''
  );
  const slug = (params.get('r') || '').trim().toLowerCase();
  const mesaRaw = parseInt(params.get('mesa') || '0', 10);

  if (!slug) {
    return (
      <CardapioLicencaBloqueada mensagem="Link inválido: restaurante não informado (?r=slug)." />
    );
  }

  const restaurante = buscarRestaurantePorSlug(slug);
  if (!restaurante) {
    return (
      <CardapioLicencaBloqueada
        mensagem={`Restaurante "${slug}" não encontrado. Verifique o link com o administrador.`}
      />
    );
  }

  const lic = verificarLicenca(restaurante);
  if (!lic.ok) {
    return <CardapioLicencaBloqueada nomeRestaurante={restaurante.nome} mensagem={lic.msg} />;
  }

  if (modo === 'cardapio-painel') {
    return <CardapioPainel restaurante={restaurante} />;
  }

  if (modo === 'cardapio-cozinha') {
    if (restaurante.modoCozinha !== 'separado') {
      return (
        <CardapioLicencaBloqueada
          nomeRestaurante={restaurante.nome}
          mensagem="Este restaurante usa balcão e cozinha na mesma tela. Use o link do balcão."
        />
      );
    }
    return <CardapioCozinha restaurante={restaurante} />;
  }

  const mesa = Number.isFinite(mesaRaw) && mesaRaw >= 1 ? mesaRaw : 0;
  if (mesa < 1 || mesa > restaurante.maxMesas) {
    return (
      <CardapioLicencaBloqueada
        nomeRestaurante={restaurante.nome}
        mensagem={`Mesa inválida. Use mesa de 1 a ${restaurante.maxMesas}.`}
      />
    );
  }

  return <CardapioCliente restaurante={restaurante} mesa={mesa} />;
}
